import type * as rtk from "@reduxjs/toolkit";

import { configureStore } from '@reduxjs/toolkit';
import projectsReducer from '../features/projects/projectsSlice';
import topicsReducer from '../features/topics/topicsSlice';
import filessReducer from '../features/files/FilesSlice';
import spacesReducer from '../features/spaces/SpaceSlice';

export const store = configureStore({
  reducer: {
    projects: projectsReducer,
    topics: topicsReducer,
    files: filessReducer,
    spaces : spacesReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
